import { render } from "./EscritorioTrabajosNoRevisados.vue?vue&type=template&id=fabce026"
import script from "./EscritorioTrabajosNoRevisados.vue?vue&type=script&lang=js"
export * from "./EscritorioTrabajosNoRevisados.vue?vue&type=script&lang=js"

import "./EscritorioTrabajosNoRevisados.vue?vue&type=style&index=0&id=fabce026&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__